import type { MessageDescriptor } from 'react-intl';
import { FormattedMessage } from 'react-intl';

import { BodyS } from '#src/atoms/typography/index.tsx';
import { FiatWalletIcon } from '#src/components/paymentMethods/Icon/FiatWalletIcon/index.tsx';
import { SorareWallet } from '#src/components/paymentMethods/SorareWallet/index.tsx';
import { useFiatBalance } from '#src/hooks/wallets/useFiatBalance.ts';
import { payment } from '#src/lib/glossary.ts';
import type { Color } from '#src/style/types.ts';

type Props = {
  withoutBalance?: boolean;
  column?: boolean;
  balanceColor?: Color;
  label?: MessageDescriptor;
};

export const FiatWallet = ({
  withoutBalance,
  column,
  balanceColor = 'var(--c-white)',
  label = payment.sorareCashWallet,
}: Props) => {
  const { availableBalanceWithCurrencySymbol } = useFiatBalance();
  return (
    <SorareWallet
      icon={<FiatWalletIcon />}
      label={<FormattedMessage {...label} />}
      balance={
        <BodyS color={balanceColor}>{availableBalanceWithCurrencySymbol}</BodyS>
      }
      withoutBalance={withoutBalance}
      column={column}
    />
  );
};
